<template lang="pug">
  v-layout.box-coupon(:class="{'disabled': !info.enabled}" column mb-3)
    v-flex.coupon-container
      v-layout.coupon-border(style="padding: 6px 20px; height:inherit;" )
        .group.first
          p.omnesMedium(style="font-size: 16px; position: relative;") Vale
            img.coupon-img(:src="icon")
          p.omnesMedium(style="font-size: 13px") por:
          p.omnesSemibold.value
            | S/
            span.omnesSemibold {{info.amount}}
            | .00
        .line
        .group.second
          p.omnesMedium(style="font-size: 16px; line-height: 1.1;") {{info.name}}
          p.omnesRegular(style="font-size: 14px; line-height: 1; margin-top: 3px; margin-bottom:10px;")
            | N° de póliza&nbsp;
            span {{numeroPoliza}}
          .code-container
            p.g-text-center.code(
              :class="{'omnesSemibold': info.code, 'default': info.noCode}"
              v-model="info.code"
              )
              | {{info.code || info.noCode}}
            v-btn.copy(:class="{'done': textCopied}" v-if="info.code" @click="copy(info.code)") {{ textCopied ? '¡Copiado!' :'Copiar código'}}
    v-flex(v-if="info.expire")
      span.coupon-expire Válido hasta el {{info.expire}}
</template>

<script>
export default {
  props: [
    'numeroPoliza',
    'info'
  ],
  data () {
    return {
      icon: require('@/assets/icons/icon-logo-agora.png'),
      canCopy: false,
      textCopied: false
    }
  },
  methods: {
    async copy (s) {
      await navigator.clipboard.writeText(s)
      this.toggleTextCopy()
    },
    toggleTextCopy () {
      this.textCopied = !this.textCopied
      setTimeout(() => {
        this.textCopied = !this.textCopied
      }, 1500)
    }
  },
  created () {
    this.canCopy = !!navigator.clipboard
  }
}
</script>

<style scoped>
p {
  margin: 0;
}

.box-coupon:last-child {
  margin-bottom: 0 !important;
}

.line {
  border-right: 1px dashed #C4C4C4;
  margin: 0 20px 0 15px;
}

.group {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.group.first {
  min-width: 95px;
  max-width: 100px;
  margin-top: 5px;
}

.group.first p {
  color: var(--first-brand-color);
}

.group.first .value,
.group.first .value span {
  display: flex;
  color: var(--fuchsia-color);
  font-size: 17px;
}

.group.first .value span {
  font-size: 27px;
  line-height: 1.5;
}

.coupon-img {
  height: 16px;
  margin-left: 5px;
  margin-top: 6px;
  position: absolute;
}

.group.second {
  width: 100%;
}

.group.second p,
.group.second span {
  margin: 0;
  color: var(--text-color)
}

.code-container {
  min-width: 130px;
  max-width: 80%;
}

.code {
  background-color: var(--first-brand-color);
  border-radius: 30px;
  color: var(--white-color) !important;
  font-size: 18px;
  padding: 0 1rem;
  min-width: 50%;
}

.code.default {
  font-size: 12px;
  line-height: 2.5;
  padding: 0 .5rem;
}

.copy {
  color: var(--first-brand-color) !important;
  cursor: pointer;
  display: flex;
  font-size: 12px;
  justify-content: center;
  text-decoration: underline;
  padding: 4px;
  user-select: none;
  margin: 4px auto;
  background-color: #fff !important;
  box-shadow: none !important;
  height: auto;
  text-transform: initial;
  border-radius: 30px;
  transition: color .5s ease-out;
}

.copy.done {
  color: var(--green-color) !important;
  transition: color .5s ease-out;
}

.copy:focus::before {
  background-color: transparent;
}

.copy:hover::before {
  background-color: transparent !important;
}

.coupon-container {
  width: 100%;
  overflow: hidden;
}

.coupon-border {
  width: 100%;
  min-height: 125px;
  max-height: 145px;
  border: 1px solid #C4C4C4;
  border-radius: 18px;
  padding: 1.5em;
  position: relative;
}

.coupon-border::before,
.coupon-border::after {
  content: "";
  width: 20px;
  height: 20px;
  background: white;
  position: absolute;
  border-radius: 10px;
  border: 1px solid #C4C4C4;
  transform: translateY(-50%);
}

.coupon-border::before {
  left: -13px;
  top: 50%;
}
.coupon-border::after {
  right: -13px;
  top: 50%;
}

.coupon-expire {
  color: #919191;
  font-style: italic;
  font-size: 12px;
  margin-left: 1rem;
}

.box-coupon.disabled p,
.box-coupon.disabled span,
.box-coupon.disabled a,
.box-coupon.disabled .copy {
  color: #919191 !important;
  pointer-events: none;
}

.box-coupon.disabled img {
  filter: grayscale(1);
  transition-property: filter;
}

.box-coupon.disabled .code-container {
  max-width: fit-content;
}

.box-coupon.disabled .code-container p {
  background-color: #919191;
  color: #fff !important;
  user-select: none;
  line-height: 1.3;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 27px;
}

@media (max-width: 390px) {
  .group.second p:nth-child(2) {
    font-size: 12px !important;
  }

  .code-container {
    min-width: 100px;
  }

  .code {
    font-size: 14px;
  }
}

@media (max-width: 370px) {
  .line {
    margin: 0 12px;
  }

  .coupon-border {
    padding: 6px 15px !important;
  }
}

@media screen and (min-width: 768px) {
  .box-coupon {
    max-width: 350px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 992px) {
  .coupon-border {
    padding: 6px 15px !important;
  }

  .group.second > p:first-child {
    font-size: 15px !important;
  }

  .group.second p:nth-child(2) {
    font-size: 12px !important;
  }

  .code.default {
    line-height: 2.5;
    font-size: 11px;
    padding: 0 3px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/generic/Coupon.vue